import { fetchListWebviewBackgroundHeader } from '@/src/requests'

export async function isHeaderImage(params, resource) {
  console.log(623495, { method: 'getList', resource: resource, params: params })
  //
  const [, data] = await fetchListWebviewBackgroundHeader({ ...params })
  //
  return { data: data.rows, total: data.count }
}
